var React = require('react');

function At (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","key":0},React.createElement("circle",{"cx":"256","cy":"256","r":"256","fill":"#fff"})),React.createElement("g",{"mask":"url(#a)","key":1},[React.createElement("path",{"fill":"#d80027","d":"M0 0h512v167l-23.2 89.7L512 345v167H0V345l29.4-89L0 167z","key":0}),React.createElement("path",{"fill":"#eee","d":"M0 167h512v178H0z","key":1})])]);
}

At.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = At;

At.default = At;
